import React, { Component } from "react";
import createEmojiPlugin from "@draft-js-plugins/emoji";
import "@draft-js-plugins/emoji/lib/plugin.css";
import "./customToolbarEditor.css";

export const emojiPlugin = createEmojiPlugin();
const { EmojiSuggestions, EmojiSelect } = emojiPlugin;

export default class SimpleEmoji extends Component {
  render() {
    return (
      <div>
        <EmojiSuggestions />
        {/* <div className="options"> */}
        {/* <EmojiSelect /> */}
        {/* </div> */}
      </div>
    );
  }
}
